import { useState, useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { Settings, LogOut, ArrowLeft, Loader2 } from 'lucide-react';
import api from '../utils/api';

export default function AdminLayout() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/users/me')
      .then(r => {
        if (r.data?.role !== 'admin') {
          navigate('/', { replace: true });
        } else {
          setUser(r.data);
        }
      })
      .catch(() => navigate('/login', { replace: true }))
      .finally(() => setLoading(false));
  }, [navigate]);

  const logout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0f0f13]">
        <Loader2 size={24} className="animate-spin text-gray-500" />
      </div>
    );
  }

  return (
    <div className="dark min-h-screen bg-[#0f0f13] text-gray-100">
      {/* 顶栏 */}
      <header className="h-14 bg-[#17171f] border-b border-white/[0.07] flex items-center px-6 gap-4">
        <div className="flex items-center gap-2.5">
          <div className="w-7 h-7 rounded-lg bg-violet-600/20 border border-violet-500/30 flex items-center justify-center">
            <Settings size={14} className="text-violet-400" />
          </div>
          <span className="font-bold text-sm text-gray-100">管理后台</span>
          <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded-md bg-red-500/10 border border-red-500/20 text-red-400 tracking-wider">
            ADMIN
          </span>
        </div>

        <div className="flex-1" />

        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-1.5 text-xs text-gray-400 hover:text-gray-200 transition-colors px-2.5 py-1.5 rounded-lg hover:bg-white/[0.05]"
        >
          <ArrowLeft size={13} />
          返回用户端
        </button>

        <div className="flex items-center gap-2 pl-3 border-l border-white/[0.07]">
          <div className="w-6 h-6 rounded-md bg-gradient-to-br from-violet-500 to-fuchsia-500 flex items-center justify-center text-[11px] font-bold text-white">
            {user?.username?.[0]?.toUpperCase()}
          </div>
          <span className="text-xs text-gray-400">{user?.username}</span>
        </div>

        <button
          onClick={logout}
          className="flex items-center gap-1.5 text-xs text-gray-500 hover:text-red-400 transition-colors px-2.5 py-1.5 rounded-lg hover:bg-red-500/[0.06]"
        >
          <LogOut size={13} />
          退出
        </button>
      </header>

      {/* 内容区 */}
      <main className="max-w-5xl mx-auto px-6 py-10">
        <Outlet />
      </main>
    </div>
  );
}
